import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUpload } from '@fortawesome/pro-solid-svg-icons';
import React, { useEffect, useState } from 'react';
import { FileUpload, FileUploadDisplay, Size } from '@salvapp/ui-components';
import { showFeedback } from '../feedback/feedbackReducer';
import { useDispatch } from 'react-redux';
import './FileUploadWrapper.scss';

interface Props {
  files: File[];
  maxFiles?: number;
  isMulti: boolean;
  onChange: (files: File[]) => void;
}

export const FileUploadWrapper = ({ files = [], maxFiles = 30, isMulti = true, onChange }: Props) => {
  const dispatch = useDispatch();
  const [filesState, setFilesState] = useState<File[]>(files);

  useEffect(() => {
    onChange(filesState);
  }, [filesState]);

  const removeFile = (index: number) => {
    const newFiles = [...filesState];
    newFiles.splice(index, 1);
    setFilesState(newFiles);
  };

  return (
    <>
      <FileUpload
        onChange={(acceptedFiles: File[]) => {
          if (acceptedFiles.length <= maxFiles) {
            setFilesState(acceptedFiles);
          } else {
            setFilesState([...filesState]);
            dispatch(
              showFeedback({
                message: 'Too many files added',
                success: false,
              })
            );
          }
        }}
        size={Size.MEDIUM}
        isMulti={isMulti}
        hideUploadedFile={true}
        externallyUpdatedFiles={filesState}
      >
        <div className='dz-message w-100 py-5'>
          <FontAwesomeIcon icon={faUpload} className='fe' />
          <p>{`Drag files to this area to attach. (Max ${maxFiles})`}</p>
        </div>
      </FileUpload>
      <div className='m-t-16'>
        <FileUploadDisplay onRemove={removeFile} files={filesState} />
      </div>
    </>
  );
};
